import AgentProfile from './AgentProfile';

export default AgentProfile;